import { useQueryClient } from '../react-query';

export const useGetMutationMeta = () => {
  const queryClient = useQueryClient();
  const meta = queryClient.getDefaultOptions().mutations?.meta;
  return meta;
};
